
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24"
  },
  "children": [
    {
      "tag": "defs",
      "children": [
        {
          "tag": "clipPath",
          "attrsMap": {
            "id": "clip-path"
          },
          "children": [
            {
              "tag": "rect",
              "attrsMap": {
                "id": "矩形_11199",
                "data-name": "矩形 11199",
                "class": "cls-1",
                "width": "24",
                "height": "24",
                "transform": "translate(211 461)"
              }
            }
          ]
        }
      ]
    },
    {
      "tag": "g",
      "attrsMap": {
        "id": "蒙版组_252",
        "data-name": "蒙版组 252",
        "class": "cls-2",
        "transform": "translate(-211 -461)"
      },
      "children": [
        {
          "tag": "path",
          "attrsMap": {
            "id": "床",
            "class": "cls-3",
            "d": "M19.889,10.884l-1.1-4.22a1.513,1.513,0,0,0-1.473-1.118h-.1V1.484A1.5,1.5,0,0,0,15.7,0H4.3A1.5,1.5,0,0,0,2.78,1.484V5.531h-.1A1.513,1.513,0,0,0,1.21,6.654L.035,11.265A1.075,1.075,0,0,0,0,11.547v2.968A1.5,1.5,0,0,0,1.519,16H18.481A1.5,1.5,0,0,0,20,14.516V11.76a3.766,3.766,0,0,0-.111-.876ZM5.362,3.711l3.494-.035V5.442H5.387Zm5.777,0,3.489-.035V5.442H11.139ZM3.792,1.484A.5.5,0,0,1,4.3.989H15.7a.5.5,0,0,1,.506.495V5.442h-.587V3.676a.971.971,0,0,0-.977-.955h-3.5a1,1,0,0,0-.712.269.949.949,0,0,0-.3.686V5.442H9.863V3.676a.971.971,0,0,0-.977-.955H5.342a.971.971,0,0,0-.957.955V5.442H3.792Zm-1.6,5.408A.5.5,0,0,1,2.7,6.521H17.316a.5.5,0,0,1,.506.371l1.1,4.22a.082.082,0,0,0,0,.035H1.109ZM18.481,15H1.519a.5.5,0,0,1-.506-.495v-2.37H18.987v2.37A.5.5,0,0,1,18.481,15Z",
            "transform": "translate(213 465)"
          }
        }
      ]
    }
  ]
})
    }
  